module.exports = __webpack_public_path__ + "img/BEN.f5c98430.svg";